"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var classNames = require("classnames");
var bind_1 = require("../../../bind");
var lodash_1 = require("lodash");
var SHOP_FILTERING_PARAMS_PRESENT_AMOUNT = 2;
var ONLY_SHOP_PARAM_PRESENT_AMOUNT = 1;
var ONLY_SHOP_AND_FOLLOW_ID_PARAMS_PRESENT_AMOUNT = 2;
var FollowButton = /** @class */ (function (_super) {
    tslib_1.__extends(FollowButton, _super);
    function FollowButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FollowButton.prototype.getDefaultText = function () {
        return I18n.t('discovery.addFollowToFeed.followThis', { type: I18n.t('discovery.addFollowToFeed.followType.search') });
    };
    FollowButton.prototype.getDefaultAddedText = function () {
        return I18n.t('discovery.addFollowToFeed.hasAddedToFeed');
    };
    FollowButton.prototype.handleClick = function (e) {
        e.preventDefault();
        if (this.props.disabled) {
            return;
        }
        this.props.openModal(this.props.trackerEventName || 'FollowButton');
    };
    FollowButton.prototype.linkText = function () {
        if (this.props.isFollowing) {
            return this.props.addedText || this.getDefaultAddedText();
        }
        return this.props.addText || this.getDefaultText();
    };
    FollowButton.prototype.tooltipText = function () {
        if (!this.props.disabled) {
            return null;
        }
        return this.props.disabledTooltipText ||
            I18n.t('discovery.addFollowToFeed.tooltipText');
    };
    FollowButton.prototype.showShopFollowerCount = function () {
        if (!this.props.followParams)
            return null;
        if (!lodash_1.get(this.props, 'followers.count'))
            return null;
        var params = Object.keys(this.props.followParams);
        if (params.length > SHOP_FILTERING_PARAMS_PRESENT_AMOUNT)
            return null;
        if (!params.includes('shop'))
            return null;
        if (params.length === ONLY_SHOP_PARAM_PRESENT_AMOUNT ||
            (params.length === ONLY_SHOP_AND_FOLLOW_ID_PARAMS_PRESENT_AMOUNT && params.includes('id'))) {
            return (React.createElement("p", { className: "mtb-half size-90 opacity-90 align-center" },
                React.createElement("span", { className: "weight-bold pr-half" }, this.props.followers.display),
                I18n.t('discovery.addFollowToFeed.followers')));
        }
        return null;
    };
    FollowButton.prototype.render = function () {
        var classes = classNames('feed-button__follow', { 'feed-button__follow--styled': !this.props.unstyled && !this.props.outlined }, { 'feed-button__follow--outlined': this.props.outlined }, { 'feed-button__follow--remove': this.props.isFollowing });
        return (React.createElement("div", { "data-tooltip-text": this.tooltipText() },
            React.createElement("a", { className: classes, onClick: this.handleClick, role: "button", "data-disabled": this.props.disabled || null }, this.linkText()),
            this.showShopFollowerCount()));
    };
    tslib_1.__decorate([
        bind_1.default
    ], FollowButton.prototype, "handleClick", null);
    return FollowButton;
}(React.Component));
exports.FollowButton = FollowButton;
exports.default = user_context_provider_1.withUserContext(FollowButton);
//# sourceMappingURL=follow_button.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/feed/follow_button.js
// module id = OYfJ
// module chunks = 20 21